import { Component } from '@angular/core';
import { IonicPage, ModalController, NavParams, NavController, LoadingController } from 'ionic-angular';
import { Form } from '../../../providers/survey';
import { Api } from '../../../providers'

@Component({
  selector: 'page-detailResponse',
  templateUrl: 'index.html'
})
export class DetailResponsePage {

  profile   : any;
  data      : any={};
  form      : any={};
  form_value: any={};
  detail:any={};

  constructor(
    public navCtrl    : NavController,
           navParams  : NavParams,
    public loadingCtrl: LoadingController,
    public modalCtrl  : ModalController,
    // public globalVar  : GlobalVar,
    public api        : Api,
    public formApi    : Form
    ) {
    // this.profile     = this.globalVar.app_user;
    this.data        = navParams.get('data');
    this.form        = navParams.get('form');
    this.form.fields = JSON.parse(this.form.form_fields);
    this.form_value  = JSON.parse(this.data.data);
    console.log("form value => ",this.form_value);
    console.log("form fields => ", this.form.fields);
  }

  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidLoad() {
    this.detail = this.getFields();
    console.log("detail data => ", this.detail);
  }


  getFields() {
    let fields = JSON.parse(this.form.form_fields);
    let new_field :any = [];
    fields.forEach(field => {
      
      if(field.type == "checkbox"){
        let temp_field : any ={};
        let new_opt:any={};
        field.options.forEach(chk => {
          let temp_opt: any = {};
          // let value =this.form_value;
          //   if(chk.label == value.label && value.label == true){
          //     temp_opt.label = chk.label;
          //     temp_opt.value = chk.value;
          //     temp_opt.checked = true;
          //   }
          //   new_opt.push(temp_opt);
        });
        temp_field.label = field.label;
        temp_field.name = field.name;
        temp_field.options = field.options;
        new_field.push(temp_field);
      }else{
        let temp_field: any = {};
        temp_field.label = field.label;
        temp_field.name = field.name;
        new_field.push(temp_field);
      }

    });
    return new_field;
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/survey/detail_response/index.ts